import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { ContentElement } from './ContentElement';
var GroupElement = /** @class */ (function (_super) {
    __extends(GroupElement, _super);
    function GroupElement(elements, elementFormat, eventMirror, textRotation) {
        if (elements === void 0) { elements = null; }
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this, undefined, undefined, undefined) || this;
        textRotation = axCoerceString(textRotation);
        console.warn('[GroupElement] not implemented');
        return _this;
    }
    Object.defineProperty(GroupElement.prototype, "elementCount", {
        // AS -> JS Bindings
        // _elementCount: number /*int*/;
        get: function () {
            console.warn('[GroupElement] - elementCount not implemented');
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    GroupElement.prototype.getElementAt = function (index /*int*/) {
        //index = index | 0;
        console.warn('[GroupElement] - getElementAt not implemented');
        return null;
    };
    GroupElement.prototype.setElements = function (value /*ASVector<any>*/) {
        //value = value;
        console.warn('[GroupElement] - setElements not implemented');
    };
    GroupElement.prototype.groupElements = function (beginIndex /*int*/, endIndex /*int*/) {
        //beginIndex = beginIndex | 0;
        //endIndex = endIndex | 0;
        console.warn('[GroupElement] - groupElements not implemented');
        return null;
    };
    GroupElement.prototype.ungroupElements = function (groupIndex /*int*/) {
        //groupIndex = groupIndex | 0;
        console.warn('[GroupElement] - ungroupElements not implemented');
    };
    GroupElement.prototype.mergeTextElements = function (beginIndex /*int*/, endIndex /*int*/) {
        //beginIndex = beginIndex | 0;
        //endIndex = endIndex | 0;
        console.warn('[GroupElement] - mergeTextElements not implemented');
        return null;
    };
    GroupElement.prototype.splitTextElement = function (elementIndex /*int*/, splitIndex /*int*/) {
        //elementIndex = elementIndex | 0;
        //splitIndex = splitIndex | 0;
        console.warn('[GroupElement] - splitTextElement not implemented');
        return null;
    };
    GroupElement.prototype.replaceElements = function (beginIndex /*int*/, endIndex /*int*/, newElements /*ASVector<any>*/) {
        //beginIndex = beginIndex | 0;
        //endIndex = endIndex | 0;
        //newElements = newElements;
        console.warn('[GroupElement] - replaceElements not implemented');
        return null;
    };
    GroupElement.prototype.getElementAtCharIndex = function (charIndex /*int*/) {
        //charIndex = charIndex | 0;
        console.warn('[GroupElement] - getElementAtCharIndex not implemented');
        return null;
    };
    GroupElement.forceNativeConstructor = true;
    GroupElement.forceNativeMethods = true;
    return GroupElement;
}(ContentElement));
export { GroupElement };
